/* Module « Qui va l'installer près de chez vous ? » (snippets/fu-installateurs.liquid).
   Un seul script pour tous les modules de la page, y compris ceux du tiroir du
   panier qui sont réaffichés à chaque modification : écoute par délégation.
   CRM : https://www.flammup.fr/api/public/installateurs (compte, demande). */
(function () {
  if (window.__fuInst) return;
  window.__fuInst = true;

  var API = 'https://www.flammup.fr/api/public/installateurs';
  var CLE_CP = 'fu_inst_cp';
  var TEL = '09 70 70 95 20';

  function suivre(nom, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', nom, params || {}); } catch (e) {}
  }
  function lireCp() { try { return window.localStorage.getItem(CLE_CP) || ''; } catch (e) { return ''; } }
  function noterCp(v) { try { window.localStorage.setItem(CLE_CP, v); } catch (e) {} }
  function el(root, sel) { return root.querySelector(sel); }
  function montrer(n, oui) { if (n) n.hidden = !oui; }

  function poster(chemin, corps) {
    return fetch(API + chemin, {
      method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, status: r.status, d: d }; });
    });
  }

  function occupe(form, oui, texte) {
    var b = form.querySelector('button[type="submit"]');
    var lib = b && b.querySelector('[data-fu-libelle]');
    if (!b || !lib) return;
    if (oui) { b.dataset.fuLibelle = lib.textContent; lib.textContent = texte; b.disabled = true; form.setAttribute('aria-busy', 'true'); }
    else { if (b.dataset.fuLibelle) lib.textContent = b.dataset.fuLibelle; b.disabled = false; form.removeAttribute('aria-busy'); }
  }

  function erreur(root, quoi, message) {
    var p = el(root, quoi === 'cp' ? '[data-fu-err-cp]' : '[data-fu-err-email]');
    var input = el(root, quoi === 'cp' ? '[name="code_postal"]' : '[name="email"]');
    if (p) { p.textContent = message || ''; montrer(p, !!message); }
    if (input) { if (message) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
  }

  function pluriel(n, un, plusieurs) { return n + ' ' + (n > 1 ? plusieurs : un); }

  function afficherCompte(root, d) {
    var compte = el(root, '[data-fu-compte]');
    var detail = el(root, '[data-fu-detail]');
    var ville = d.commune || 'chez vous';
    compte.textContent = '';
    // Le chiffre ne compte que notre base ; la liste envoyée est complétée au moment
    // de la préparer. On ne l'affiche que s'il rassure (10 et plus), jamais « peu ».
    var montreNb = d.nb >= 10 && !d.zone_faible;
    if (montreNb) {
      var fort = document.createElement('strong');
      fort.textContent = pluriel(d.nb, 'professionnel', 'professionnels');
      compte.appendChild(fort);
      compte.appendChild(document.createTextNode(' de la pose et du conduit à moins de 40 km de ' + ville + '.'));
    } else {
      compte.appendChild(document.createTextNode('Nous préparons la liste des professionnels de la pose et du conduit autour de ' + ville + '.'));
    }
    var txt = '';
    detail.classList.remove('fu-inst__detail--faible');
    if (d.nb_partenaires > 0 && d.partenaires && d.partenaires.length) {
      txt = (montreNb ? (d.nb_partenaires > 1 ? 'Dont ' + d.nb_partenaires + ' partenaires Flamm’Up : ' : 'Dont 1 partenaire Flamm’Up : ')
        : (d.nb_partenaires > 1 ? 'Avec ' + d.nb_partenaires + ' partenaires Flamm’Up : ' : 'Avec 1 partenaire Flamm’Up : ')) +
        d.partenaires.map(function (p) { return p.nom + (p.commune ? ' (' + p.commune + ')' : ''); }).join(', ') +
        (d.nb_partenaires > d.partenaires.length ? '…' : '.');
    }
    txt = (txt ? txt + ' ' : '') + 'Recevez-la par e-mail avec leurs coordonnées et nos conseils pour l’appel.';
    detail.textContent = txt;
    montrer(detail, !!txt);

    var wrap = el(root, '[data-fu-communes-wrap]');
    var select = el(root, '[data-fu-communes]');
    if (d.communes && d.communes.length > 1) {
      select.textContent = '';
      d.communes.forEach(function (nom) {
        var o = document.createElement('option');
        o.value = nom; o.textContent = nom;
        if (nom === d.commune) o.selected = true;
        select.appendChild(o);
      });
      montrer(wrap, true);
    } else {
      montrer(wrap, false);
    }
    root.dataset.commune = d.commune || '';
    root.dataset.cp = d.code_postal || '';
    montrer(el(root, '[data-fu-res]'), true);
  }

  function chercher(root, commune) {
    var form = el(root, '[data-fu-etape="cp"]');
    var input = el(root, '[name="code_postal"]');
    var cp = String(input.value || '').replace(/\s+/g, '');
    input.value = cp;
    if (!/^\d{5}$/.test(cp)) { erreur(root, 'cp', 'Saisissez un code postal à 5 chiffres.'); input.focus(); return; }
    erreur(root, 'cp', '');
    occupe(form, true, 'Recherche…');
    var emplacement = root.getAttribute('data-emplacement') || 'page';
    poster('/compte', { code_postal: cp, commune: commune || '', appareil: root.getAttribute('data-appareil') || '' })
      .then(function (r) {
        if (!r.ok) {
          erreur(root, 'cp', r.status === 404 ? 'Ce code postal ne correspond à aucune commune.' : r.status === 429 ? 'Trop de recherches d’affilée : réessayez dans quelques minutes.' : (r.status === 400 && r.d.error ? 'Saisissez un code postal à 5 chiffres.' : 'La recherche n’a pas abouti. Réessayez ou appelez le ' + TEL + '.'));
          return;
        }
        noterCp(cp);
        afficherCompte(root, r.d);
        suivre('installateurs_compte', { emplacement: emplacement, nb: r.d.nb, zone_faible: !!r.d.zone_faible });
        if (!commune) { var c = el(root, '[data-fu-compte]'); if (c) c.focus({ preventScroll: true }); }
      })
      .catch(function () { erreur(root, 'cp', 'La recherche n’a pas abouti. Réessayez ou appelez le ' + TEL + '.'); })
      .then(function () { occupe(form, false); });
  }

  function demander(root) {
    var form = el(root, '[data-fu-etape="email"]');
    var input = el(root, '[name="email"]');
    var email = String(input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { erreur(root, 'email', 'Vérifiez votre adresse e-mail.'); input.focus(); return; }
    erreur(root, 'email', '');
    var piege = form.querySelector('[name="site_web"]');
    var consent = form.querySelector('[name="consent_offres"]');
    var handle = root.getAttribute('data-produit-handle');
    var variante = root.getAttribute('data-variante');
    try { var v = new URLSearchParams(window.location.search).get('variant'); if (v) variante = v; } catch (e) {}
    var emplacement = root.getAttribute('data-emplacement') || 'page';
    var corps = {
      email: email,
      code_postal: root.dataset.cp || '',
      commune: root.dataset.commune || '',
      emplacement: emplacement,
      appareil: root.getAttribute('data-appareil') || '',
      page_url: window.location.origin + window.location.pathname,
      consent_offres: !!(consent && consent.checked),
      site_web: piege ? piege.value : ''
    };
    if (handle) corps.produit = { handle: handle, titre: root.getAttribute('data-produit-titre') || '', variant_id: variante || '' };
    occupe(form, true, 'Envoi…');
    poster('/demande', corps)
      .then(function (r) {
        if (!r.ok) {
          erreur(root, 'email', r.status === 400 && r.d.error ? 'Vérifiez votre adresse e-mail et votre code postal.' : r.status === 429 ? 'Trop de demandes d’affilée : réessayez plus tard ou appelez le ' + TEL + '.' : 'La demande n’est pas partie. Réessayez ou appelez le ' + TEL + '.');
          return;
        }
        var ville = root.dataset.commune ? ' autour de ' + root.dataset.commune : '';
        var ok = el(root, '[data-fu-ok]');
        el(root, '[data-fu-ok-texte]').textContent = 'C’est noté. Vous recevez ' + (handle ? 'votre devis et ' : '') +
          'la liste des installateurs' + ville + ' par e-mail, sous 24 h ouvrées. Une question ? ' + TEL + '.';
        montrer(el(root, '[data-fu-res]'), false);
        montrer(el(root, '[data-fu-etape="cp"]'), false);
        montrer(ok, true);
        ok.focus({ preventScroll: true });
        suivre('installateurs_demande', { emplacement: emplacement, avec_devis: !!handle, consentement: corps.consent_offres });
      })
      .catch(function () { erreur(root, 'email', 'La demande n’est pas partie. Réessayez ou appelez le ' + TEL + '.'); })
      .then(function () { occupe(form, false); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var root = form && form.closest ? form.closest('[data-fu-inst]') : null;
    if (!root) return;
    e.preventDefault();
    var etape = form.getAttribute('data-fu-etape');
    if (etape === 'cp') chercher(root);
    else if (etape === 'email') demander(root);
  });

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches('[data-fu-communes]')) return;
    var root = s.closest('[data-fu-inst]');
    if (root) chercher(root, s.value);
  });

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-fu-inst] [name="code_postal"]') && !t.value) { var cp = lireCp(); if (cp) t.value = cp; }
  });

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-fu-rappel]') : null;
    if (!a) return;
    var d = document.getElementById('fu-rappel');
    if (d) { d.open = true; }
  });

  // Vu une fois par emplacement (mesure de l'affichage réel, pas du chargement).
  function observer() {
    var vus = {};
    var cibles = document.querySelectorAll('[data-fu-inst]');
    if (!('IntersectionObserver' in window) || !cibles.length) return;
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (en) {
        if (!en.isIntersecting) return;
        var emp = en.target.getAttribute('data-emplacement') || 'page';
        io.unobserve(en.target);
        if (vus[emp]) return;
        vus[emp] = true;
        suivre('installateurs_vu', { emplacement: emp });
      });
    }, { threshold: 0.5 });
    cibles.forEach(function (c) { io.observe(c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observer); else observer();
})();
